"use client";

import React from "react";
import logo from "@/assets/sidebar/magic-stick.svg";
import { SectionItem } from "@/components/sidebar/models/section-item";
import SidebarSectionWithItems from "@/components/sidebar/sidebar-components/sidebar-section-with-items";
import SidebarItemProps from "../models/sidebar-item-props";

const AiToolsSidebarSection = ({ isOpen = true }: SidebarItemProps) => {
  const items = [
    // { title: "Convert Vocals", href: "/convert" },
    // { title: "Create Voices", href: "/custom" },
    { title: "Stem Splitter", href: "/stem-splitter" },
    { title: "Vocal Remover", href: "/vocal-remover" },
    // {
    //   title: "Text to Music",
    //   href: "/text-to-music",
    // },
    // { title: "Voice Blending", href: "/voice-blending" },
    { title: "Key and BPM Finder", href: "/key-bpm-finder" },
    {
      title: "Text to Speech",
      href: "/text-to-speech",
    },
    // {
    //   title: "Duets",
    //   href: "/duets",
    // },
    // {
    //   title: "Beat Machine",
    //   href: "/beat-machine",
    // },
    {
      title: "AI Mastering",
      href: "/ai-mastering",
    },
    {
      title: "Mashup Songs",
      href: "/mashup",
      soon: true,
    },
  ] as SectionItem[];

  return (
    <SidebarSectionWithItems
      image={logo}
      title="AI Tools"
      items={items}
      isOpen={isOpen}
    />
  );
};

export default AiToolsSidebarSection;
